var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var getIcon = function (icon, size, fill, label) {
    if (label === void 0) { label = ''; }
    var fillEncoded = fill.replace('#', '%23');
    var dataUri = icon.replace('XXXXX', fillEncoded);
    return {
        label: label,
        display: 'inline-block',
        backgroundSize: 'contain',
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
        backgroundImage: "url(\"".concat(dataUri, "\")"),
        width: size,
        height: size,
    };
};
var icon = {
    dragHandle: "data:image/svg+xml,%3Csvg width='128' height='128' viewBox='0 0 128 128' xmlns='http://www.w3.org/2000/svg'%3E%3Ctitle%3Eregular/drag%3C/title%3E%3Cpath fill='XXXXX' d='M0 0h16v16H0V0zm37 37h16v16H37V37zm0 75h16v16H37v-16zM0 37h16v16H0V37zM37 0h16v16H37V0zm0 75h16v16H37V75zM75 0h16v16H75V0zm0 75h16v16H75V75zm0-38h16v16H75V37zm0 75h16v16H75v-16zM112 0h16v16h-16V0zm0 75h16v16h-16V75zm0-38h16v16h-16V37zM0 112h16v16H0v-16zm0-37h16v16H0V75zm112 37h16v16h-16v-16z'  fill-rule='evenodd'/%3E%3C/svg%3E",
    collapse: "data:image/svg+xml,%3Csvg baseProfile='tiny' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill='XXXXX' d='M15.298 12.454L8 5.157.702 12.454 0 11.752l8-8 8 8z'/%3E%3C/svg%3E",
    expand: "data:image/svg+xml,%3Csvg baseProfile='tiny' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill='XXXXX' d='M8 12.685l-8-8 .702-.702L8 11.281l7.298-7.298.702.702z'/%3E%3C/svg%3E",
};
export var sortable = {
    display: 'table',
    width: '100%',
    '&.pcty-sortable-disabled': {
        '.pcty-sortable-handle': __assign(__assign({}, getIcon(icon.dragHandle, 16, '#a6a6a6')), { cursor: 'not-allowed' }),
    },
};
export var ghost = {
    filter: 'grayscale(100%)',
    opacity: 0.25,
};
export var handle = __assign(__assign({}, getIcon(icon.dragHandle, 16, '#1588af')), { cursor: 'grab', position: 'relative', zIndex: 1 });
export var item = {
    background: '#ffffff',
    color: '#222222',
    display: 'table-row',
    lineHeight: "".concat(16, "px"),
    width: '100%',
    '&.pcty-sortable-item-disabled': {
        color: "".concat('#cccccc', " !important"),
        '.pcty-sortable-handle': __assign(__assign({}, getIcon(icon.dragHandle, 16, '#a6a6a6')), { cursor: 'not-allowed' }),
    },
};
export var section = {
    display: 'table-row-group',
    width: '100%',
    '&.pcty-sortable-section-disabled': {
        '& .pcty-sortable-section-title': {
            color: "".concat('#cccccc', " !important"),
        },
        '.pcty-sortable-handle': __assign(__assign({}, getIcon(icon.dragHandle, 16, '#a6a6a6')), { cursor: 'not-allowed' }),
    },
    '.pcty-sortable-item:not(.pcty-sortable-section-title)': {
        '.pcty-sortable-column': {
            '.pcty-sortable-handle': {
                display: 'none',
            },
            '.pcty-sortable-column-inner': {
                '.pcty-sortable-column-inner-column': {
                    '&:first-of-type': {
                        width: 24,
                    },
                },
                '.pcty-sortable-handle': {
                    display: 'block',
                },
            },
        },
    },
};
export var sectionTitle = __assign(__assign({}, item), { background: '#f5f5f5', '.pcty-sortable-column': {
        fontWeight: 'bold',
    } });
export var header = __assign(__assign({}, item), { color: '#666666', fontWeight: 'bold' });
export var column = {
    borderBottom: "1px solid ".concat('#cccccc'),
    display: 'table-cell',
    padding: 8,
    verticalAlign: 'middle',
    '&.pcty-sortable-border-top': {
        borderTop: "1px solid ".concat('#cccccc'),
    },
    '&.pcty-sortable-border-none': {
        border: 'none',
    },
    '&:first-of-type': {
        paddingRight: 0,
        width: 16,
    },
    '.pcty-sortable-column-inner': {
        display: 'table',
        width: '100%',
        '.pcty-sortable-column-inner-column': {
            display: 'table-cell',
            verticalAlign: 'middle',
            '&:first-of-type': {
                width: 0,
            },
        },
        '.pcty-sortable-handle': {
            display: 'none',
        },
    },
};
export var drag = {
    opacity: '1 !important',
    '&.pcty-sortable-section': {
        backgroundColor: '#1588AF',
        display: 'table',
        width: '100%',
        '.pcty-sortable-section-title': {
            backgroundColor: '#1588AF',
            color: '#ffffff',
            '.pcty-sortable-handle': __assign({}, getIcon(icon.dragHandle, 16, '#ffffff')),
        },
        '.pcty-sortable-item:not(.pcty-sortable-section-title)': {
            backgroundColor: '#DFF4F8',
            display: 'table-row',
            width: '100%',
        },
    },
    '&:not(.pcty-sortable-section)': {
        '&.pcty-sortable-item': {
            backgroundColor: '#1588AF',
            color: '#ffffff',
            display: 'table',
            width: '100%',
            '.pcty-sortable-handle': __assign({}, getIcon(icon.dragHandle, 16, '#ffffff')),
            '.pcty-sortable-column-inner': {
                '.pcty-sortable-handle': {
                    display: 'none',
                },
            },
        },
    },
};
export var sectionEmpty = {
    display: 'table-row-group',
    width: '100%',
};
export var staticSortable = {
    borderBottom: "1px solid ".concat('#cccccc'),
    borderCollapse: 'collapse',
    boxSizing: 'border-box',
    display: 'table',
    margin: 0,
    padding: 0,
    width: '100%',
};
export var staticGroup = {
    display: 'table',
    width: '100%',
};
export var staticItem = {
    background: '#ffffff',
    color: '#222222',
    display: 'table-row',
    lineHeight: "".concat(16, "px"),
    width: '100%',
};
export var staticDivider = __assign(__assign({}, staticItem), { cursor: 'default', fontWeight: 'bold', position: 'relative', width: '100%', '.pcty-list-column': {
        cursor: 'pointer',
        border: 'none',
        backgroundColor: '#f5f5f5',
        borderTop: "1px solid ".concat('#cccccc'),
        '&:last-of-type': {
            position: 'relative',
            '&:after': {
                content: '""',
                lineHeight: "".concat(32, "px"),
                position: 'absolute',
                top: 8,
                right: 12,
            },
        },
    } });
export var staticDividerInactive = {
    '&:last-of-type': {
        '&:after': __assign({}, getIcon(icon.expand, 16, '#222222')),
    },
};
export var staticDividerActive = {
    '&:last-of-type': {
        '&:after': __assign({}, getIcon(icon.collapse, 16, '#222222')),
    },
};
export var staticColumn = {
    borderTop: "1px solid ".concat('#cccccc'),
    display: 'table-cell',
    padding: 8,
    verticalAlign: 'middle',
};
export var staticItemChild = {
    '.pcty-list-column': {
        '&:first-of-type': {
            paddingLeft: 32,
        },
    },
};
